<app-dc-header class="headerContainer">
    <ng-container class="heading">Data Protection Addendum</ng-container>
  </app-dc-header>
  
  <app-dc-pane noHeader="true" class="mainContainer"> <div class="modal-body" [innerHTML]="text"></div></app-dc-pane>